import React from 'react';

import css from './FieldLabel.module.css';

const FieldLabel = ({ children, required = false, htmlFor, className, as: Tag = 'label' }) => (
  <Tag
    htmlFor={htmlFor}
    className={`${className || ''} ${required ? css.required : ''}`.trim()}
  >
    {children}
  </Tag>
);

export default FieldLabel;
